import styled from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const Content = styled.div`
  padding-bottom: 16px;

  ${fromMd} {
    padding-bottom: 36px;
  }
`

export const Loading = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 400px;
  padding-bottom: 16px;
  width: 100%;

  ${fromMd} {
    min-height: 431px;
    padding-bottom: 36px;
  }
`
